import React, { Component } from 'react';

import { withRouter } from 'react-router-dom';

import { Link } from 'react-router-dom';
import { Navbar, Modal, Button, TextInput, Textarea } from 'react-materialize';

import * as M from 'materialize-css'

import * as emailjs from 'emailjs-com';
import cx from 'classnames';

class NavMenu extends Component {
    state = {
        top: true,
        transparent: true,
        prevScrollPosition: window.pageYOffset,
        visible: true,
        showModal: false,
        loading: false,
        formValid: false,
        modalMessage: '',
        firstName: '',
        lastName: '',
        email: '',
        contactNumber: '',
        message: '',
    }

    handleValidity = ()=>{
        if (this.state.firstName === '' ||
            this.state.contactNumber === '' ||
            this.state.message === ''
        ) {
            this.setState({
                formValid: false
            })
        } else {
            this.setState({
                formValid: true
            })
        }
    }

    handleSubmit = async (e)=>{
        e.preventDefault()
        const confirmModal = M.Modal.getInstance(document.querySelector('#confirmModal'));
        this.setState({
            loading: true,
        })
        const service_id = "default_service";
        const template_id = "template_0jdiJPp6";
        const user_id = "user_Wg0MJHOS35ip5pdov67c9"
        let template_params = {
            "first_name": this.state.firstName,
            "last_name": this.state.lastName,
            "message": this.state.message,
            "contact_number": this.state.contactNumber,
            "email": this.state.email
        };
        console.log(this.state.formValid)
        if (this.state.formValid) {
            await emailjs.sendForm(service_id, template_id, template_params, user_id).then(
                this.setState({
                    loading: false,
                })
            ).then(console.log('message sent'))
            this.setState({
                modalTitle: 'Success',
                modalMessage: `Thank you for your interest in Phuma Phambili Procurement and Projects.
                Your message has been successfully sent. Our team will review and we 
                will be in touch with you as soon as humanly possible.`
            })
            confirmModal.open()
        } else {
            this.setState({
                modalTitle: 'Invalid',
                modalMessage: 'You have entered invalid information. Please make sure that you fill in all fields and that they are valid.'
            })
            confirmModal.open()
        }
    }

    setActive = (e)=>{
        console.log(e.nextSibling)
    }

    showModal = ()=>{
        this.setState({
            showModal: true,
        })
    }

    handleScroll = ()=>{
        const {prevScrollPosition} = this.state;

        const currentScrollPosition = window.pageYOffset;
        const visible = prevScrollPosition > currentScrollPosition;

        this.setState({
            prevScrollPosition: currentScrollPosition,
            visible
        });

        if (currentScrollPosition < 0.2 * window.innerHeight) {
            this.setState({
                transparent: true,
            })
        } else {
            this.setState({
                transparent: false,
            })
        }
    }

    handleFName = (e)=>{
        this.setState({
            firstName: e.target.value
        })
        this.handleValidity();
    }

    handleLName = (e)=>{
        this.setState({
            lastName: e.target.value
        })
        this.handleValidity();
    }

    handleEmail = (e)=>{
        this.setState({
            email: e.target.value
        })
        this.handleValidity();
    }

    handleCNumber = (e)=>{
        this.setState({
            contactNumber: e.target.value
        })
        this.handleValidity();
    }

    handleMessage = (e)=>{
        this.setState({
            message: e.target.value
        })
        this.handleValidity();
    }

    componentDidMount = ()=>{
        window.addEventListener('scroll', this.handleScroll)
    }

    componentWillUnmount = ()=>{
        window.removeEventListener('scroll', this.handleScroll)
    }
    render() {
        return(
            <Navbar brand={
                <div className="logo">
                    <Link to="/">
                        <span className="logo-accessibility">
                            P3 Logo
                        </span>
                    </Link>
                </div>
            } alignLinks="right" className={cx({'navbar-bg': !this.state.transparent},{'transparent-bg': this.state.top}, 'px-3', 'scrollEffect', {'scrollEffect--hide': !this.state.visible} )}>
                <div className="nav-wrapper">
                    <ul>
                        <li className={cx('navlink', {'active':this.props.location.pathname === '/'})}><Link onClick={this.setActive} to="/">HOME</Link></li>
                        <li className={cx('navlink', {'active':this.props.location.pathname === '/about'})}><Link onClick={this.setActive} to="/about">ABOUT</Link></li>
                        <li className={cx('navlink', {'active':this.props.location.pathname === '/products'})}><Link onClick={this.setActive} to="/products">PRODUCTS</Link></li>
                        <li className={cx('navlink', {'active':this.props.location.pathname === '/services'})}><Link onClick={this.setActive} to="/services">SERVICES</Link></li>
                        <li className={cx('navlink', {'active':this.props.location.pathname === '/industries'})}><Link onClick={this.setActive} to="/industries">INDUSTRIES</Link></li>
                        <li className={cx('navlink')}><button href="#modal1" className="trigger modal-trigger">CONTACT</button></li>
                    </ul>
                </div>

                <Modal id="modal1" header="Contact Us" actions={
                    <Button waves="light" type='submit' className="brand-color" onClick={this.handleSubmit}>
                        <i class="fas fa-envelope-open"></i>
                        &nbsp;SUBMIT
                    </Button>
                }>
                    <form id="ContactForm" className="col s12" action=".">
                        <p>Please fill in the form below.</p>
                        <div className="row">
                            <TextInput onBlur={this.handleFName} validate={true} s={6} label="First Name" id="firstName" required/>
                            <TextInput onBlur={this.handleLName} validate={true} s={6} label="Last Name" id="lastName" required/>
                        </div>
                        <div className="row">
                            <TextInput onBlur={this.handleEmail} validate={true} s={6} label="Email" id="email" required/>
                            <TextInput onBlur={this.handleCNumber} validate={true} s={6} type="number" label="Contact Number" id="contactNumber" required/>
                        </div>
                        <div className="row">
                            <Textarea onBlur={this.handleMessage} s={12} id="message" required label="Message" />
                        </div>
                    </form>
                </Modal>

                <Modal id="confirmModal" header={this.state.modalTitle}>
                    {this.state.modalMessage}
                </Modal>
            </Navbar>
        )
    }
};

export default withRouter(NavMenu);